module.exports = __webpack_public_path__ + "assets/d8ee5e2c82aa13753d458bf5380d9108.svg";